import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/AntDesign.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/AntDesign.json';

export default createIconSet(glyphMap, 'anticon', font);
